import clasolLogo from '../media/clasol.png';

const dark = [21, 25, 29];
const muted = [104, 114, 125];
const divider = [220, 224, 228];

let logoDataUrlPromise;

const readBlobAsDataUrl = (blob) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = () => reject(new Error('No se ha podido cargar el logo de Clasol.'));
  reader.readAsDataURL(blob);
});

export const loadPdfReportLogo = () => {
  if (!logoDataUrlPromise) {
    logoDataUrlPromise = fetch(clasolLogo)
      .then((response) => {
        if (!response.ok) {
          throw new Error('No se ha podido cargar el logo de Clasol.');
        }

        return response.blob();
      })
      .then(readBlobAsDataUrl);
  }

  return logoDataUrlPromise;
};

export const drawPdfReportHeader = (doc, {
  logoDataUrl,
  pageNumber,
  rightDetail,
  subtitle,
  title,
  totalPages,
}) => {
  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();
  const rightEdge = pageWidth - 14;

  doc.setTextColor(...dark);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(16);
  doc.text(title, 14, 15);

  doc.addImage(logoDataUrl, 'PNG', rightEdge - 20, 5, 20, 20);

  doc.setFont('helvetica', 'normal');
  doc.setTextColor(...muted);
  doc.setFontSize(8);
  doc.text(subtitle, 14, 22);
  doc.text(rightDetail, rightEdge - 26, 22, { align: 'right' });

  doc.setDrawColor(...divider);
  doc.line(14, 27, rightEdge, 27);

  doc.setFontSize(7.5);
  doc.text(`Pagina ${pageNumber} de ${totalPages}`, rightEdge, pageHeight - 7, { align: 'right' });
};
